import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useAppConfigContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export function useGAPageTracking() {
    const config = useAppConfigContext();
    const { isAmr } = useAssignedAppTypeContext();
    const gaMeasurementId: string = isAmr ? config?.gaMeasurementIdAmr : config?.gaMeasurementId;

    useEffect(() => {
        if (gaMeasurementId) {
            ReactGA.initialize(gaMeasurementId, {
                testMode: false,
                gaOptions: {
                    nonIteraction: false,
                },
            });
        }
    }, []);
}
